import { useMutation } from '@tanstack/react-query'

import { submitCompletedWorkflowOfDraftPaymentRequests } from '@src/api'
import { DefaultApiSubmitCompletedWorkflowOfDraftPaymentRequestsRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useSubmitCompletedWorkflowOfDraftPaymentRequests = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (
      params: DefaultApiSubmitCompletedWorkflowOfDraftPaymentRequestsRequest
    ) => submitCompletedWorkflowOfDraftPaymentRequests(axiosInstance, params),
  })
}
